import React, { useEffect, useState } from "react";
import {
	Button,
	Card,
	CardBody,
	CardHeader,
	CardTitle,
	Col,
	FormGroup,
	Input,
	Row,
} from "reactstrap";
import Loading from "components/loadingSpinner/Loading";
import history from "utils/createBrowserHistory";
import { retrieveFailAlert } from "utils/alertUtils";
import dayjs from "dayjs";
import Camera from "assets/img/placeholder.png";
import { LoanPeriod, PATHS, SaleType } from "../constants/Constants";
import useSetAccount from "./useSetAccount";
import { getAcctListBySearch } from "./AccountAPI";
import { showApiError } from "../utils/errorRoutingUtils";
import { useFromUser } from "../stores/LocalStorageHelper";
import useDateRangeStore from "../stores/DateRangeStore";
import useRoute from "../hooks/useRoute";
import AccountTable from "./AccountTable";
import PageLayout from "../components/layouts/PageLayout";
import InputElement from "../features/forms/components/InputElement";

const AccountSearchList = () => {
	const dealerID = useFromUser("dealerID");
	const locationID = useFromUser("locationID");
	const firstName = useFromUser("firstName");
	const lastName = useFromUser("lastName");
	const dcLoginID = useFromUser("ID");
	const { fromDate, toDate } = useDateRangeStore();

	const initialFromDate = dayjs(fromDate).format("YYYY-MM-DD");
	const initialToDate = dayjs(toDate).format("YYYY-MM-DD");
	console.log("initialFromDate: " + initialFromDate);
	console.log("initialToDate: " + initialToDate);

	const [selectedOption, setSelectedOption] = useState("dateRange");

	const [fromDT, setFromDT] = useState(initialFromDate);
	const [toDT, setToDT] = useState(initialToDate);

	const [acctNo, setAcctNo] = useState("");
	const [stockNo, setStockNo] = useState("");
	const [vin, setVin] = useState("");
	const [customer, setCustomer] = useState("");
	const [acctNum, setAcctNum] = useState("");
	const accountDetailPage = useRoute(PATHS.ACCT_DETAIL);

	const currencyFormatter = new Intl.NumberFormat("en-US", {
		style: "currency",
		currency: "USD",
	});

	const handleOptionChange = (event) => {
		setSelectedOption(event.target.value);
	};

	const setAccount = useSetAccount();
	const [filter, setFilter] = useState("");

	const [data, setData] = useState([]);
	const [loadingList, setLoadingList] = useState(false);
	const homeRoute = useRoute(PATHS.DASHBOARD);

	// Handles row click and fetches Account data
	const handleRowClick = (deal) => {
		getDealData(deal.dealID);
	};
	// Fetches the list of deals
	const getListData = (filter) => {
		if (dealerID && locationID) {
			getAcctListBySearch(locationID, filter)
				.then((response) => {
					const formattedData = dataFormat(response.data.content);
					setData(formattedData);
					setLoadingList(false);
				})
				.catch((error) => {
					showApiError(error, retrieveFailAlert);
					history.push(homeRoute);
				});
		}
	};

	const updateSearch = () => {
		if (selectedOption === "dateRange")
			setFilter(
				` ((acct.LoanDate  >= CONVERT(DATETIME, '${fromDT}', 102)) AND  (acct.LoanDate  <= CONVERT(DATETIME, '${toDT}', 102))  ) `
			);
		if (selectedOption === "stockNo")
			setFilter(` acct.StockNum like '%${stockNo}%' `);

		if (selectedOption === "vin") setFilter(` acct.VIN  like '%${vin}%' `);
		if (selectedOption === "customer")
			setFilter(
				` (buyer.firstName + ' ' + buyer.lastName) like '%${customer}%' `
			);
		if (selectedOption === "acctNum")
			setFilter(` acct.accountNumber like '%${acctNum}%' `);
		setLoadingList(true);
	};

	// Formats the JSON response object
	const dataFormat = (content) => {
		const container = Object.keys(content).map((key) => {
			let container = {};

			container.thumbnail = (
				<div>
					<img
						className="zoom"
						alt="vehicle"
						src={
							content[key].thumbnail
								? `${content[key].thumbnail}?lastmod=${Date.now()}`
								: Camera
						}
						onError={(e) => {
							e.target.onerror = null;
							e.target.src = Camera;
						}}
						width="250"
						height="150"
					/>
				</div>
			);

			container.buyerID = content[key].buyerID;
			container.coBuyerID = content[key].coBuyerID;
			container.inventoryID = content[key].inventoryID;
			container.status = content[key].mainStatus;
			container.statusLabel = content[key].statusLabel;
			container.phone = content[key].phone != null ? content[key].phone : "";
			container.fullName = content[key].name;
			container.cofullName = content[key].cobuyer;
			container.email = content[key].email;
			container.customerDetails =
				container.fullName +
				" " +
				container.email +
				" " +
				container.phone +
				" " +
				(content[key].coBuyerID ? "coBuyer: " + content[key].cobuyer : "");
			container.vehicle = content[key].vehicle;
			container.stock = content[key].stock;
			container.vin = content[key].vin;
			container.vehicleStatus = content[key].vehicleStatus;
			container.vehicleDetails =
				container.vehicle + " " + container.stock + " " + container.vin;
			container.year = content[key].year;
			container.make = content[key].make;
			container.model = content[key].model;

			container.loanDate = content[key].loanDate
				? content[key].loanDate.substr(0, 10)
				: (container.loanDate = null);

			container.saleType =
				SaleType[content[key].saleType]?.label || "Unknown type";
			container.accountNumber = content[key].accountNumber;
			container.term = content[key].term;
			container.payment = content[key].payment;
			container.loanPeriod = LoanPeriod[content[key].period].label;
			container.payoffMethod = content[key].payoffMethod;
			container.closeDate = content[key].closeDate;

			container.account =
				container.lable +
				" " +
				dayjs(container.loanDate).format("MM/DD/YYYY") +
				" " +
				container.saleType +
				" " +
				container.accountNumber +
				" " +
				container.term +
				" " +
				currencyFormatter.format(container.payment) +
				" " +
				container.loanPeriod;
			container.Actions = (
				<>
					<div className="text-center">
						<div
							className="btn-md btn btn-primary"
							onClick={() => {
								history.push(accountDetailPage, {
									acctID: content[key].acctID,
								});

								//getAccountData(content[key].acctID);
							}}
						>
							<i className="icon-big text-center nc-icon nc-paper text-default"></i>
							<span className="noMobile">&nbsp;View</span>
						</div>
						{/* Edit Account button for troubleshooting purposes only - do NOT delete -Peyman 5/28/2025 */}
						{/* <div
							className="btn-md btn btn-primary"
							onClick={() => {
								accountEditPage(content[key].acctID);

								//getAccountData(content[key].acctID);
							}}
						>
							<i className="icon-big text-center nc-icon nc-paper text-default"></i>
							<span className="noMobile">&nbsp;Edit</span>
						</div> */}
					</div>
				</>
			);
			return container;
		});
		return container;
	};
	const handleFromDateBlur = () => {
		const fromDate = new Date(fromDT);
		const toDate = new Date(toDT);
		const diffTime = Math.abs(toDate - fromDate);
		const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

		if (diffDays > 730 || diffDays < 0) {
			toDate.setFullYear(fromDate.getFullYear() + 2); // Set toDate to 2 years after fromDate
			setToDT(toDate.toISOString().split("T")[0]);
		}
	};

	const handleToDateBlur = (e) => {
		const fromDate = new Date(fromDT);
		const toDate = new Date(toDT);
		const diffTime = Math.abs(toDate - fromDate);
		const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
		if (diffDays > 730 || diffDays < 0) {
			fromDate.setFullYear(toDate.getFullYear() - 2); // Set fromDate to 2 years before toDate
			setFromDT(fromDate.toISOString().split("T")[0]);
		}
	};

	useEffect(() => {
		if (loadingList) getListData(filter);
		// eslint-disable-next-line
	}, [loadingList]);

	return (
		<PageLayout>
			<Row>
				<Col>
					<Card>
						<CardHeader>
							<CardTitle tag="h4">Quick Account Search</CardTitle>
						</CardHeader>
						<CardBody>
							<Row>
								<Col xs="12" sm="6" md="3">
									<FormGroup>
										<Col xs="auto">
											<Input
												label="Loan Date Range"
												type="radio"
												name="dateRange"
												value="dateRange"
												checked={selectedOption === "dateRange"}
												onChange={handleOptionChange}
											/>
										</Col>
										<Col>
											<InputElement
												disableValidation={true}
												value={fromDT}
												onBlur={handleFromDateBlur}
												onChange={(e) => setFromDT(e.target.value)}
												name="fromDate"
												label="From Date"
												type="date"
												colSize="col-sm-1.5"
											/>
										</Col>
										<Col>
											<InputElement
												disableValidation={true}
												value={toDT}
												onBlur={handleToDateBlur}
												onChange={(e) => setToDT(e.target.value)}
												name="toDate"
												label="To Date"
												type="date"
												colSize="col-sm-1.5"
											/>
										</Col>
										<div style={{ color: "green" }}>
											The date range cannot exceed 2 years.
										</div>
									</FormGroup>
								</Col>
								<Col xs="12" sm="6" md="2">
									<FormGroup>
										<Row>
											<Col xs="auto">
												<Input
													type="radio"
													name="stockNo"
													value="stockNo"
													checked={selectedOption === "stockNo"}
													onChange={handleOptionChange}
												/>
											</Col>
											<Col>
												<InputElement
													disableValidation={true}
													value={stockNo}
													name="stockNo"
													label="Stock Number"
													type="text"
													onChange={(e) => setStockNo(e.target.value)}
													colSize="col-sm-1.5"
												/>
											</Col>
										</Row>
									</FormGroup>
								</Col>
								<Col xs="12" sm="6" md="2">
									<FormGroup>
										<Row>
											<Col xs="auto">
												<Input
													type="radio"
													name="vin"
													value="vin"
													checked={selectedOption === "vin"}
													onChange={handleOptionChange}
												/>
											</Col>
											<Col>
												<InputElement
													disableValidation={true}
													value={vin}
													name="vin"
													label="Vin Number"
													type="text"
													onChange={(e) => setVin(e.target.value)}
													colSize="col-sm-1.5"
												/>
											</Col>
										</Row>
									</FormGroup>
								</Col>
								<Col xs="12" sm="6" md="2">
									<FormGroup>
										<Row>
											<Col xs="auto">
												<Input
													type="radio"
													name="customer"
													value="customer"
													checked={selectedOption === "customer"}
													onChange={handleOptionChange}
												/>
											</Col>
											<Col>
												<InputElement
													disableValidation={true}
													value={customer}
													name="customer"
													label="Customer"
													type="text"
													onChange={(e) => setCustomer(e.target.value)}
													colSize="col-sm-1.5"
												/>
											</Col>
										</Row>
									</FormGroup>
								</Col>
								<Col xs="12" sm="6" md="2">
									<FormGroup>
										<Row>
											<Col xs="auto">
												<Input
													type="radio"
													name="acctNum"
													value="acctNum"
													checked={selectedOption === "acctNum"}
													onChange={handleOptionChange}
												/>
											</Col>
											<Col>
												<InputElement
													disableValidation={true}
													value={acctNum}
													name="acctNum"
													label="Account Number"
													type="text"
													onChange={(e) => setAcctNum(e.target.value)}
													colSize="col-sm-1.5"
												/>
											</Col>
										</Row>
									</FormGroup>
								</Col>
							</Row>
							<div className="text-center mt-3">
								<Button color="primary" onClick={updateSearch}>
									Search
								</Button>
							</div>
						</CardBody>
					</Card>
				</Col>
			</Row>

			<div>
				{loadingList && <Loading />}
				{!loadingList && (
					<AccountTable data={data} onRowClick={handleRowClick} />
				)}
			</div>
		</PageLayout>
	);
};

export default AccountSearchList;
